import React from "react";
import $ from "jquery";
import * as omnimap from "../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../../managementMaintenance/tableContext/schedule/functions/callBackFunctions";
import * as GC from "../common";
import {MergeUniquely} from "../function/functions";

class CreateManagementUnit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      naam: "",
      naamRequiredAlert: "",
      code: GC.CodeAutoFill("BE"),
      begin: "", //GC.curday("-"),
      end: "", //GC.curday("-"),
      active: true,
      beginRequiredAlert: false,
      endRequiredAlert: false,
      codeRequiredAlert: false,
      codeAlertText: "",
      // ------------------------------
      laagNameList: [],
      laagList: [],
      veldList: [],
      // ------------------------------
      // modal form field
      formLaagName: null,
      bufferGrootte: null,
      nederlandsVeld: null,
      wetenschappelijkVeld: null,
      wettens: [
        { id: 1, value: "Paragraaf 3.1", isChecked: false },
        { id: 2, value: "Paragraaf 3.2", isChecked: false },
        { id: 3, value: "Paragraaf 3.3", isChecked: false },
      ],
      doelsoortens: [
        { id: 1, value: "Doelsoort", isChecked: false },
        { id: 2, value: "Rode lijst", isChecked: false },
      ],
      onderhoudslagen: null,
    };
    this.baseState = this.state;
    this.handleInputChange = this.handleInputChange.bind(this);
    this.laagSelection = this.laagSelection.bind(this);
  }

  handleCheckChieldElementWetten = (event) => {
    let wettens = this.state.wettens;
    wettens.forEach((wetten) => {
      if (wetten.value === event.target.value)
        wetten.isChecked = event.target.checked;
    });
    this.setState({ wettens: wettens });
  };

  handleCheckChieldElementDoelsoorten = (event) => {
    let doelsoortens = this.state.doelsoortens;
    doelsoortens.forEach((doelsoorten) => {
      if (doelsoorten.value === event.target.value)
        doelsoorten.isChecked = event.target.checked;
    });
    this.setState({ doelsoortens: doelsoortens });
  };

  resetForm = async () => {
    await this.setState(this.baseState);
    await this.setState({ code: GC.CodeAutoFill("BE") });
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  async ExecuteShortCut(message) {
    if (window.$mm_schedule_isOpen) {
      try {
        await window.$mm_schedule_ws.send(message);

        // return window.$mm_schedule_ws.send(message);
      } catch (error) {
        alert("There is no connection");
      }
    } else {
      alert("There is no connection");
    }
  }

  start = function () {
    var wsImpl = window.WebSocket || window.MozWebSocket;
    // create a new websocket and connect
    window.$mm_schedule_ws = new wsImpl("ws://localhost:8084/");
    // when data is comming from the server, this metod is called
    window.$mm_schedule_ws.onmessage = function (evt) {
      // alert("Natuurbeschermingscheck is voltooid.");
      return evt.data;
    };
    // when the connection is established, this method is called
    window.$mm_schedule_ws.onopen = function () {
      window.$mm_schedule_isOpen = true;
    };
    // when the connection is closed, this method is called
    window.$mm_schedule_ws.onclose = function () {
      window.$mm_schedule_isOpen = false;
    };
    window.$mm_schedule_ws.onerror = function (e) {
      console.log(e.data);
    };
  };

  async handleSubmit() {
    // this.start();
    $("#cover-spin").show(0);
    var selectedIds = [];
    var selectedRows = [];
    var laagNaamList = [];
    //--------------------
    let arcgisresultaat = [];
    $("#example")
      .dataTable()
      .$("tr.selected")
      .each(function () {
        selectedIds.push($(this).attr("rowId"));
      });

    // ---------------------------------------------
    // seçili satırların tüm değerlerinin bulunması
    for (let index in selectedIds) {
      let founded
      if(this.props["from"] && this.props["from"] === "WORK_PLAN"){
        founded = window.window.$mm_work_plans_Glist.find(
            (x) => x.identification === selectedIds[index]
        );
      } else {
        founded = window.$mm_schedule_Glist.find(
            (x) => x.identification === selectedIds[index]
        );
      }

      selectedRows.push({
        GisratioId: founded.algemeenGisratio,
        Identifier: founded.identification,
      });
      laagNaamList.push({
        GisratioId: founded.algemeenGisratio,
        Identifier: founded.identification,
        LaagNaam: founded.beheeractiviteitLaag,
      });
    }
    let layersSelected = []

    for(const selected of laagNaamList){
      layersSelected.push(selected['LaagNaam'])
    }
    // Make unique
    layersSelected = layersSelected.filter((v, i, a) => a.indexOf(v) === i);

    for(const layer of this.state.laagNameList){
      for(const selectedLayer of layersSelected){
        const index = layersSelected.indexOf(layer);
        if (index !== -1) {
          layersSelected.splice(index, 1);
        }
      }
    }

    if(layersSelected.length > 0){
      let texts = ""
      for (const layer of layersSelected){
        texts = texts + "\n" + layer
      }
      if(!window.confirm("Sommige lagen niet gevonden in het ArcGIS Pro-project. \n" + texts)){
        $("#plannig_natuurbeschermingscheck_modal").modal("hide");
        $("#cover-spin").hide(0);
        return
      }
    }




    await GC.sleep(2000).then(() => {
      var that = this;

      var uniqueLaagNaam = [
        ...new Set(laagNaamList && laagNaamList.map((item) => item.LaagNaam)),
      ];
      let checkedLayers = 0
      const allLayers = uniqueLaagNaam.length

      for (let i = 0; i < uniqueLaagNaam.length; i++) {
        const laagNaam = uniqueLaagNaam[i];

        // * arayüzden alınan verilerin arcgis'e post edilmesi
        const model = {
          RequestId: "ReqId",
          Token: "test",
          RequestType: 8,
          LayerSettings: [
            {
              LayerName: laagNaam,
              AttributeName: this.state.onderhoudslagen
                .filter((x) => x.content["algemeen-laag"] === laagNaam)
                .map((f) => f.content["algemeen-sleutelveld"])[0],
            },
          ],
          Data: {
            LayerName: laagNaam, //"maaivakken",
            // Features: [...selectedRows],
            Features: [
              ...laagNaamList
                .filter((x) => x.LaagNaam === laagNaam)
                .map((f) => {
                  return {
                    GisratioId: f.GisratioId,
                    Identifier: f.Identifier,
                  };
                }),
            ],
            Buffer: this.state.bufferGrootte,
            NatuurBeschermingsLayerName: this.state.formLaagName,
            DutchFieldName: this.state.nederlandsVeld || "",
            ScientificfieldName: this.state.wetenschappelijkVeld || "",
            SortGroupFieldName: "SOORTGROEP",
          },
        };

        this.ExecuteShortCut(JSON.stringify(model));

        window.$mm_schedule_ws.onmessage = async function (evt) {
          const obj = JSON.parse(evt.data);
          // let arcgisresultaat = [];

          if (obj.Success) {
            for (let i = 0; i < obj.Data.length; i++) {
              const result = obj.Data[i];
              await arcgisresultaat.push({
                gisratioid: result.GisRatioID,
                werkregelidentification: result.Identifier,
                hits: result.Hits.map((hit) => {
                  return {
                    nederlandsenaam: hit.DutchFieldValue,
                    scientificname: hit.ScientificFieldValue,
                  };
                }),
              });
            }
            // obj.Data.forEach(async (result) => { });
            // * arcgis'ten gelen verinin omnimap'a post edilmesi.
            let model = {
              content: {
                wetten: [
                  ...that.state.wettens
                    .filter((x) => x.isChecked)
                    .map((i) => {
                      return i.value;
                    }),
                ],
                doelsoorten: [
                  ...that.state.doelsoortens
                    .filter((x) => x.isChecked)
                    .map((i) => {
                      return i.value;
                    }),
                ],
                arcgisresultaat: arcgisresultaat,
              },
              relationships: {
                definition: {
                  code: "CHECK_NATUURBESCHERMING",
                },
              },
            };

            omnimap
              .GenericInstanceAction(model, "POST")
              .then((res) => {})
              .catch((err) => {
                alert("error:" + err);
                $("#plannig_natuurbeschermingscheck_modal").modal("hide");
              });
            checkedLayers++;
            if (checkedLayers === allLayers){
              $("#plannig_natuurbeschermingscheck_modal").modal("hide");
              $("#cover-spin").hide(0);
            }
          } else {
            const msg = obj["Message"];
            if(msg.includes("LayerSetting x")) {
              alert("Laag niet gevonden in het ArcGIS Pro project.")
            }
            else {
             alert(msg.split('. ')[0])
            }
            checkedLayers++;
            if (checkedLayers === allLayers){
              $("#plannig_natuurbeschermingscheck_modal").modal("hide");
              $("#cover-spin").hide(0);
            }
          }
        };
      }
    });
  }
  hideModal(){
    $("#plannig_natuurbeschermingscheck_modal").modal("hide");
  }
  hideSpin(){
    $("#cover-spin").hide(0);
  }
  hideAll(){
    this.hideModal();
    this.hideSpin();
  }
  async getPlannigLaagName() {
    var that = this;

    var model = {
      RequestId: "ReqId",
      Token: "test",
      RequestType: 5,
      LayerSettings: null,
      Data: null,
    };

    await this.ExecuteShortCut(JSON.stringify(model));

    window.$mm_schedule_ws.onmessage = async function (evt) {
      const obj = JSON.parse(evt.data);
      let _laagNameList = [];
      let _laagList = [];
      if (!obj.Data){
        alert('You are offline!')
        $("#plannig_natuurbeschermingscheck_modal").modal("hide");
        $("#cover-spin").hide(0);
        return
      }
      obj.Data.forEach((element) => {
        _laagNameList.push(element.Name);
        _laagList.push(element);
      });
      that.setState({ laagNameList: _laagNameList, laagList: _laagList });
    };
  }

  laagSelection(event) {
    var filtered = this.state.laagList.filter(
      (x) => x.Name === event.target.value
    );
    this.setState({
      veldList: filtered[0].Attributes,
      formLaagName: event.target.value,
    });
  }

  async componentDidMount() {
    this.start();
    var that = this;
    $("#plannig_natuurbeschermingscheck_modal").on(
      "show.bs.modal",
      async function (event) {
        that.getPlannigLaagName();
        let _onderhoudslagen = await omnimap.FillTableAction(
          {
            content: [
              {
                key: "algemeen-actief",
                and_or: "AND",
                values: [],
                datatype: "BOOLEAN",
              },
            ],
            context: [],
            definitions: [process.env.REACT_APP_CATALOG_ONDERHOUDSLAGEN],
            statuses: [],
          },
          1
        );
        that.setState({ onderhoudslagen: _onderhoudslagen.data });
      }
    );
  }

  render() {
    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        id="plannig_natuurbeschermingscheck_modal"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Natuurbeschermingscheck</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <label>Laag</label>
              <select class="form-control" onChange={this.laagSelection}>
                <option>selecteren</option>
                {this.state.laagNameList.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>

              {/* Buffer grootte */}
              <label>Buffergrootte</label>
              <input
                type="number"
                min="0"
                className="form-control"
                autocomplete="off"
                name="bufferGrootte"
                onChange={this.handleInputChange}
              />

              {/* Nederlands veld */}
              <label>Nederlands veld</label>
              <select
                class="form-control"
                name="nederlandsVeld"
                onChange={this.handleInputChange}
              >
                {this.state.veldList.map((option) => (
                  <option key={option.FieldType} value={option.Name}>
                    {option.Name}
                  </option>
                ))}
              </select>

              {/* Wetenschappelijk veld */}
              <label>Wetenschappelijk veld</label>
              <select
                class="form-control"
                name="wetenschappelijkVeld"
                onChange={this.handleInputChange}
              >
                {this.state.veldList.map((option) => (
                  <option key={option.FieldType} value={option.Name}>
                    {option.Name}
                  </option>
                ))}
              </select>

              {/* Wettelijke status */}
              <label>Wettelijke status</label>
              <div id="wetten-group">
                {this.state.wettens.map((wetten) => {
                  return (
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        key={wetten.id}
                        onClick={this.handleCheckChieldElementWetten}
                        type="checkbox"
                        checked={wetten.isChecked}
                        value={wetten.value}
                      />
                      <label className="form-check-label">{wetten.value}</label>
                    </div>
                  );
                })}
              </div>

              {/* Overige status */}
              <label>Overige statussen</label>

              <div id="overige-statusen">
                {this.state.doelsoortens.map((doelsoorten) => {
                  return (
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        key={doelsoorten.id}
                        onClick={this.handleCheckChieldElementDoelsoorten}
                        type="checkbox"
                        checked={doelsoorten.isChecked}
                        value={doelsoorten.value}
                      />
                      <label className="form-check-label">
                        {doelsoorten.value}
                      </label>
                    </div>
                  );
                })}
                {/* <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    defaultValue
                  />
                  <label className="form-check-label">Doelsoort</label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    defaultValue
                  />
                  <label className="form-check-label">Rode lijst</label>
                </div>
              */}
              </div>

              <br />
              <br />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                id="save_beheereenheid"
                className="btn-modal"
                onClick={this.handleSubmit.bind(this)}
              >
                Verwerken
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateManagementUnit;
